import css from 'styled-jsx/css';

const styles = css.global`#conte-com-santander .img-conte-com-santander-desk {
    display: none;
}

#conte-com-santander {
    overflow: hidden;
    padding: 16px 0 48px;
    position: relative;
}

#conte-com-santander .img-conte-com-santander {
    margin-top: -50px;
    width: 100%;
    min-width: 320.462px;
}

#conte-com-santander .conte-com-santander-conteudo {
    display: flex;
    flex-direction: column;
    gap: 24px;
    /* max-width: 514px; */
}

#conte-com-santander .conte-com-santander-title {
    color: #C00;
    text-align: center;
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
}

#conte-com-santander .conte-com-santander-text {
    color: #444;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#conte-com-santander .conte-com-santander-text b {
    font-weight: 600;
}

#conte-com-santander .conte-com-santander-topico {
    display: flex;
    gap: 24px;
    align-items: flex-start;
}

#conte-com-santander .elipses {
    background-image: url("assets/home24/elipse.png");
    width: 211px;
    height: 231px;
    position: absolute;
    top: 0;
    left: 0;
    opacity: .3;
}

#conte-com-santander-button {
    height: 48px;
    width: 100%;
    max-width: 272px;
    margin: auto;
}

@media (min-width: 800px) {
    #conte-com-santander .img-conte-com-santander {
        display: none;
    }

    #conte-com-santander {
        overflow: hidden;
        padding: 77px 0 141px;
    }

    #conte-com-santander .img-conte-com-santander-desk {
        display: block;
        width: 800px;
        margin-right: -110px;
        margin-left: -120px;
        margin-top: -50px;
        margin-bottom: -110px;
        z-index: 2;
        position: relative;
    }

    #conte-com-santander .conte-com-santander-contain {
        display: flex;
        align-items: center;
    }

    #conte-com-santander .conte-com-santander-title {
        text-align: left;
        font-size: 40px;
        font-weight: 800;
        line-height: 60px;
        margin-bottom: -8px;
        margin-top: 0;
    }

    #conte-com-santander-button {
        max-width: 272px;
        z-index: 3;
        margin: 0;
    }

    #conte-com-santander .elipses {
        width: 407px;
        height: 232px;
    }
    
}`;

export default styles;